import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { getShoppingCenters } from 'hooks/useUser';
import FiltersApi from 'libs/api/filters';

const api = new FiltersApi('');

const useFilters = () => {
  const { t } = useTranslation();
  const shoppingCenters = useRecoilValue(getShoppingCenters);
  const [searchParams] = useSearchParams();
  const [backendFilters, setBackendFilters] = useState({});
  const groupBy = searchParams.get('by_group');

  const [filters, setFilters] = useState([
    {
      title: t('Outlet Village'),
      type: 'select',
      name: 'by_shopping_center',
      values: shoppingCenters.map((i) => ({
        value: i.id,
        title: i.title,
      })),
    },
    {
      title: t('Periodo'),
      type: 'select',
      name: 'by_group',
      values: [
        { value: '', title: t('Periodo') },
        { value: 'day', title: t('Giornaliero') },
        { value: 'week', title: t('Settimanale') },
        { value: 'month', title: t('Mensile') },
        { value: 'year', title: t('Anno') },
      ],
    },
    {
      title: t('Trading calendar'),
      type: 'select',
      serverKey: 'by_calendar_categories',
      name: 'by_calendar_category_id',
      values: [],
    },
    {
      title: t('Giorno'),
      type: 'select',
      serverKey: 'day_types',
      name: 'by_day_type',
      values: [],
    },
    {
      title: t('Aperture'),
      type: 'select',
      serverKey: 'type_closes',
      name: 'by_type_close',
      values: [],
    },
    {
      title: t('Intervallo Date'),
      type: 'range',
      name: 'range',
      format: 'DD-MM-YYYY',
      keys: ['by_date_from', 'by_date_to'],
    },
  ]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get();
        setFilters((s) => {
          return s.map((f) => {
            if (data) {
              if (data[f.serverKey]) {
                return {
                  ...f,
                  values: data[f.serverKey]?.map((i) => ({
                    value: i.value,
                    key: i.key,
                    title: i.title,
                  })),
                };
              }
            }
            return f;
          });
        });
        setBackendFilters(data);
      } catch (e) {
        console.log('er', e);
      }
    })();
  }, []);

  useEffect(() => {
    if (shoppingCenters) {
      setFilters((s) => {
        return s.map((f) => {
          if (f.name === 'by_shopping_center') {
            return {
              ...f,
              values: shoppingCenters.map((i) => ({
                value: i.id,
                title: i.title,
              })),
            };
          }
          return f;
        });
      });
    }
  }, [shoppingCenters]);

  return {
    filters,
    groupBy,
    backendFilters,
  };
};

export { useFilters };
